// 9fbef606107a605d69c0edbcd8029e5d
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '@tcp/core/src/utils/labels/globalLogin.labels';

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
const getErrorMessage = (loginState) => {
  const labels = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);
  const errorCode = loginState && loginState.get('errorCode');
  const errorParam =
    (loginState && loginState.get('errorParameters')) ||
    (loginState && loginState.getIn(['errors', '0', 'errorParameters']));

  const lockTimeValue =
    loginState && loginState.getIn(['errors', '0', 'errorParameters', 'lockTime']);

  const emailValue = loginState && loginState.getIn(['errors', '0', 'errorParameters', 'email']);

  const lockTime = errorParam?.lockTime || lockTimeValue || '30';

  const dynamicLabels = getDynamicLabelValues('dynamic.account_d');
  labels['lbl_login_error_.2010'] = dynamicLabels['lbl_login_error_.2010'];

  if (
    (errorCode && labels[`lbl_login_error_${errorCode}`]) ||
    labels[`lbl_login_error_.${errorCode}`]
  ) {
    let errLbl = labels[`lbl_login_error_${errorCode}`] || labels[`lbl_login_error_.${errorCode}`];

    if (errorCode === '.MULTIPLE_OTP_ATTEMPT' && errorParam && lockTime) {
      errLbl = errLbl.replace('#lockTime', lockTime);
    }

    if (errorCode === '_ERR_ACCOUNT_EXISTS_IN_SESSION' && errorParam && emailValue) {
      errLbl = errLbl.replace('#emailValue#', emailValue);
    }

    return errLbl;
  }
  return (
    (loginState && loginState.getIn(['errorMessage', '_error'])) ||
    (labels && labels.lbl_login_error)
  );
};

export default getErrorMessage;
